<template>
  <!-- footer start -->
  <div>
    <div class="footer-bar"> 
    
      <div class="footer-info">
        <div class="left">
          <img src="../assets/images/logo-footer.png" />
          <p>地址：浙江省台州市三门县海润街道兴业街1号</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三门湾科创广场三楼</p>
          <p>官网：sanmencfy.com</p>
          <p>邮箱：admin@sanmencfy.com</p>
        </div>
        <div class="nav" v-for="(i, index) in navList" :key="index">
          <h2>{{ i.name }}</h2>
          <router-link 
            class="btn-a" 
            v-for="(j,index) in i.children" 
            :key="index" 
            :to="{path: j.path , query:{id: j.id}}">
            {{ j.name }}
          </router-link>
        </div>

        <div class="nav">
          <h2>关于我们</h2>
          <router-link  class="btn-a"  v-for="(item,index) in aboutUSList" :key="index" :to="{path: item.openUrl , query:{newId: item.id}}">
            {{ item.title }}
          </router-link>
        </div>

        <div class="right"> 
          <h2>关注或联系我们</h2>
          <p>添加三门冲锋衣公众号、小程序了解最新产业信息</p>
          <div class="qr-code">
            <img src="../assets/images/code.png"/>
            <img src="../assets/images/code_right.png"/>
          </div>
          <div>
            <span>咨询热线:</span>
            <span class="phone">（0576）83337336</span>
          </div>
        </div>
      </div>
    </div>
    <div class="coryright">
      Copyright © 2022 sanmencfy.com All Rights Reserved. | 三门县科学技术局 版权所有 | 浙江理工大学三门研究院提供技术支持
      <span class="coryright-icp">
        |
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >浙ICP备2024074374号-1</a>
      </span>
    </div>

  </div>
  <!-- footer end -->
</template>

<script>
import {getBasicInfoByPageForFront} from "@/api/sm/news";
export default {
  name: 'Footer',
  data () {
    return {
     
      navList:[
        {
          name:'冲锋衣产业链',
          path:'home',
          children: [ 
            {
              id:"1",
              name: "生产厂家",
              desc: "生产厂家简要介绍",
              path: "/ecosphere",
            },
            {
              id:"2",
              name: "销售服务商",
              desc: "销售服务商简要介绍",
              path: "/ecosphere",
            },
            {
              id:"3",
              name: "原料供应商",
              desc: "原料供应商简要介绍",
              path: "/ecosphere",
            },
            {
              id:"4",
              name: "其他服务商",
              desc: "其他服务商简要介绍",
              path: "/ecosphere",
            },
          ]
        },
        {
          name:'公共服务',
          path:'home',
          children: [
            {
              name: "产业政策",
              desc: "产业政策、综合体专项政策概要",
              path: "/policy",
            },
            {
              name: "检验检测服务",
              desc: "相关检验设备详细介绍",
              path: "/inspectionService",
            },
            {
              name: "T台走秀",
              desc: "相关T台介绍，申请使用T台说明",
              path: "/runwayShow",
            },
            {
              name: "培训视频",
              desc: "冲锋衣产业的各类培训视频",
              path: "/video",
            },
            {
              name: "智能制造",
              desc: "介绍智能制造情况",
              path: "/intellect",
            },
          ]
        }
        // ,
        // {
        //   name:'关于我们',
        //   path:'home',
        //   children: [
        //    {
        //     name:'三门冲锋衣产业介绍',
        //     path:'/about',
        //    },
        //    {
        //     name:'三门冲锋衣产业大事记',
        //     path:'/about',
        //    },
        //    {
        //     name:'三门冲锋衣产业创新服务综合体介绍',
        //     path:'/about',
        //    } 
        //   ]
        // }
      ],
      // baseColumn:{
      //     title:"入驻冲锋衣产业创新服务综合体",
      //     text:"立即入驻三门冲锋衣产业创新服务综合体线上平台，体验多项免费服务，掌握冲锋衣产业政策资讯，了解企业投资合作需求等信息，帮您快速实现相关资源精准高效匹配。"
      // },
      aboutUSList:[]
    }
  },
  created(){
    this.getBaseColumnList();
    this.getAboutUSList();
  },
  methods: {
    getBaseColumnList(){
      let params = {
        ownSystem: 0,
        columnCode: 'module_home',
        pageSize: 10,
        pageIndex: 1
      };
      getBasicInfoByPageForFront(params).then((res) => {
          if (res.data) {
            this.baseColumnList = this.sortKey(res.data.data,'id');
            this.baseColumn = this.baseColumnList[this.baseColumnList.length-1];
          }
      });
    },
    getAboutUSList(){
      let params = {
        ownSystem: 0,
        columnCode: 'module_aboultus',
        pageSize: 10,
        pageIndex: 1
      };
      getBasicInfoByPageForFront(params).then((res) => {
          if (res.data) {
            this.aboutUSList = this.sortKey(res.data.data,'id');
          }
      });
    },

    // 提交申请
    doSave(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.dialogVisible = false;
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },


    // 取消弹窗
    doCancel(){
      this.dialogVisible = false;
      this.$refs[formName].resetFields();
    },
    sortKey(array,key){
                 return array.sort(function(a,b){
                     var x = a[key];
                     var y = b[key];
                     return ((x<y)?-1:(x>y)?1:0)
                 })
            },
  
            handleCheckedServicesChange(value) {
        // let checkedCount = value.length;
        // this.checkAll = checkedCount === this.cities.length;
        // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    }
  }
}
</script>
 
<style lang="scss" scoped> 
.footer-bar{ 
  width: 1400px; 
  height: inherit;
  margin: auto;
}
.footer-rz{
  height: 320px;
  width: 100%;
  padding: 60px 0px;
  text-align: center;

  h2{
    font-size: 30px;
    margin-bottom: 10px;
  }
  p{
    color:$gray-color;
    margin-bottom: 40px;
  }
}
.footer-info{
  @mixin text{
    line-height: 36px;
    font-size: 14px;
    color: #b4bacc; 
  }

  display: flex;
  width: 100%;
  padding:60px 0px; 
  .left{
    width: 330px;
    p{
      color:$gray-l-color;
      font-size: 12px;
      line-height: 2;
    }
  }
  .nav{
    width: 0px;
    flex-grow: 1;
    margin-right: 50px;

    h2{
      color:#fff;
      line-height: 50px;
      border-bottom: 1px solid rgba(141,146,153,.4);
      font-size: 16px;
      margin-bottom: 10px;
    }
    .btn-a{
      display: block; 
      transition: 0.2s;
      @include text;
      &:hover{
        color:#fff;
      }
    }
  }
  .right{
    width: 400px;
    h2{
      color:#fff;
      line-height: 50px;
    }
    p{
      @include text;
    }
    span{
      @include text;  
    }
    .phone{
      font-size:30px
    }
    .qr-code{
      padding:20px 0px;
      img{
        width: 90px;
        height: 90px;
        margin-right: 30px;
      }
    }
  }
}

  .coryright{
    color: #6d7a9e;
    width: 1400px;
    line-height: 60px;
    border-top: 1px solid rgba(141,146,153,0.4);
    font-size: 12px;
    margin: auto;
    text-align: center;
    margin-top: 40px;
    .coryright-icp a{
      color: inherit;
      text-decoration: none;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  .el-dialog__body{
    padding: 30px 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterBox.vue